// Add your custom JS here.

const { offset } = require("@popperjs/core");

const is_home = () => {
	return document.body.classList.contains("home");
}

// Google Map
if (!projects[0].mapForgeEnabled) { // Check if map forge is enabled
	window.console.log('Map Forge is not enabled');
	var mapScript = document.createElement("script");
	mapScript.setAttribute("src", "https://maps.googleapis.com/maps/api/js?key=" + xcel_vars.map_key + "&v=weekly&map_ids=ae380644405d9b8b&v=beta&libraries=marker,drawing,geometry,places,visualization&callback=createMap");
	document.body.append(mapScript);

	window.map = null;
	let bounds = null;

	window.createMap = function () {
		window.map = new google.maps.Map(document.getElementById("google-map"), {
			mapId: "ae380644405d9b8b",
			center: new google.maps.LatLng(39.42187678136931, -76.47626391482008),
			maxZoom: projects.length == 1 ? parseFloat(projects[0].zoomLevel) : null,
			tilt: 0,
			mapTypeId: "roadmap",
			streetViewControl: false,
			zoomControlOptions: {
				position: google.maps.ControlPosition.RIGHT_TOP,
			},
			fullscreenControlOptions: {
				position: google.maps.ControlPosition.RIGHT_TOP,
			},
			styles: [
				{
					stylers: [{}],
				},
			],
		});

		bounds = new google.maps.LatLngBounds();

		// Create Map Layers
		window.existingTransmissionLines = [];
		window.proposedTransmissionLines = [];
		window.existingSubstationMarkers = [];
		window.existingSubstationUpgradedMarkers = [];
		window.proposedSubstationMarkers = [];
		window.opportunityMarkers = [];
		window.pastOpportunityMarkers = [];
		window.simulationMarkers = [];
		window.substationFences = [];

		projects.forEach((project) => {
			project.data.forEach((layer) => {
				if (layer.layer_type == "line") {
					if (layer.line_type == "Existing") {
						let projectName = layer.title;
						window.existingTransmissionLines[projectName] = new google.maps.Data({ map: window.map });
						window.existingTransmissionLines[projectName].addGeoJson(layer.data);
						window.existingTransmissionLines[projectName].addListener("click", function (e) {
							showInfoWindow("line", is_home() ? project.project : layer.title, 0, e.latLng, project.url);
						});
						window.existingTransmissionLines[projectName].setStyle({
							strokeWeight: 5,
							strokeOpacity: 1,
							strokeColor: "#00e3a4",
						});
						document.querySelectorAll("[data-id='window.existingTransmissionLines']")[0].parentElement.parentElement.style.display = "block";
					} else {
						let projectName = layer.title;
						window.proposedTransmissionLines[projectName] = new google.maps.Data({ map: window.map });
						window.proposedTransmissionLines[projectName].addGeoJson(layer.data);
						window.proposedTransmissionLines[projectName].addListener("click", function (e) {
							showInfoWindow("line", is_home() ? project.project : layer.title, 0, e.latLng, project.url);
						});
						window.proposedTransmissionLines[projectName].setStyle({
							strokeWeight: 5,
							strokeOpacity: 1,
							strokeColor: "#ffc107",
						});
						document.querySelectorAll("[data-id='window.proposedTransmissionLines']")[0].parentElement.parentElement.style.display = "block"; 	
					}
				} else if (layer.layer_type == "marker") {
					let marker = null;
					const coordinate = new google.maps.LatLng(layer.lat, layer.lng);
					bounds.extend(coordinate);
					if (layer.marker_type == "Substation Marker") {
						const htmlMarker = document.createElement("div");
						if (layer.data == "Existing Substation") {
							htmlMarker.className = "circle black";
							marker = new google.maps.marker.AdvancedMarkerElement({
								map: window.map,
								position: { lat: layer.lat, lng: layer.lng },
								content: htmlMarker,
							});
							window.existingSubstationMarkers.push(marker);
							document.querySelectorAll("[data-id='window.existingSubstationMarkers']")[0].parentElement.parentElement.style.display = "block"; 
						} else if (layer.data == "Existing Substation to be Upgraded") {
							htmlMarker.className = "circle green";
							marker = new google.maps.marker.AdvancedMarkerElement({
								map: window.map,
								position: { lat: layer.lat, lng: layer.lng },
								content: htmlMarker,
							});
							window.existingSubstationUpgradedMarkers.push(marker);
							document.querySelectorAll("[data-id='window.existingSubstationUpgradedMarkers']")[0].parentElement.parentElement.style.display = "block"; 
						} else if (layer.data == "Proposed New Substation") {
							htmlMarker.className = "circle yellow";
							marker = new google.maps.marker.AdvancedMarkerElement({
								map: window.map,
								position: { lat: layer.lat, lng: layer.lng },
								content: htmlMarker,
							});
							window.proposedSubstationMarkers.push(marker);
							document.querySelectorAll("[data-id='window.proposedSubstationMarkers']")[0].parentElement.parentElement.style.display = "block";
						}
						google.maps.event.addListener(marker, "click", function (e) {
							showInfoWindow("substation", layer.title, -15, this.position, layer.has_project ? project.url : null);
						});
					} else if (layer.marker_type == "Opportunity Marker" || layer.marker_type == "Past Opportunity Marker") {
						const opportunityMarker = document.createElement("img");
						if (layer.marker_type == "Opportunity Marker") {
							opportunityMarker.src = "https://vizbgebsrp-d68fccf334b8cc57-endpoint.azureedge.net/blobvizbgebsrpf33c68ba6d/wp-content/uploads/2024/03/icon-open-house-marker.svg";
							opportunityMarker.className = "opportunity-marker";
							marker = new google.maps.marker.AdvancedMarkerElement({
								map,
								position: { lat: layer.lat, lng: layer.lng },
								content: opportunityMarker,
								title: "Community Engagement Opportunity",
							});
							window.opportunityMarkers.push(marker);
							document.querySelectorAll("[data-id='window.opportunityMarkers']")[0].parentElement.parentElement.style.display = "block";
						} else if (layer.marker_type == "Past Opportunity Marker") {
							opportunityMarker.src = "https://vizbgebsrp-d68fccf334b8cc57-endpoint.azureedge.net/blobvizbgebsrpf33c68ba6d/wp-content/uploads/2024/09/icon-open-house-marker-past.svg";
							opportunityMarker.className = "past-opportunity-marker";
							marker = new google.maps.marker.AdvancedMarkerElement({
								map,
								position: { lat: layer.lat, lng: layer.lng },
								content: opportunityMarker,
								title: "Previously Held Community Engagement Opportunity",
							});
							window.pastOpportunityMarkers.push(marker);
							document.querySelectorAll("[data-id='window.pastOpportunityMarkers']")[0].parentElement.parentElement.style.display = "block";
						}
						google.maps.event.addListener(marker, "click", function (e) {
							showInfoWindow("opportunity", layer.data, -25, this.position);
						});
					} else if (layer.marker_type == "Photo Sim Marker" && projects.length == 1) {
						const simulationIcon = document.createElement("img");
						simulationIcon.src = "https://vizbgebsrp-d68fccf334b8cc57-endpoint.azureedge.net/blobvizbgebsrpf33c68ba6d/wp-content/uploads/2024/03/icon-photo-sim.svg";
						simulationIcon.className = "sim-marker";
						marker = new google.maps.marker.AdvancedMarkerElement({
							map,
							position: { lat: layer.lat, lng: layer.lng },
							content: simulationIcon,
							title: "Photo Simulation",
							id: layer.data.id,
						});
						window.simulationMarkers.push(marker);
						document.querySelectorAll("[data-id='window.simulationMarkers']")[0].parentElement.parentElement.style.display = "block";
						google.maps.event.addListener(marker, "click", function (e) {
							showInfoWindow("simulation", layer.data.id, -30, this.position);
						});
					}
				}
				if (layer.layer_type == "substation_fence") {
					let fenceData = {
						zoom: layer.zoom,
						data: new google.maps.Data({ map: window.map })
					};
					fenceData.data.addGeoJson(layer.data);
					fenceData.data.setMap(map.getZoom() >= fenceData.zoom ? window.map : null);
					fenceData.data.setStyle({
						fillColor: "#000000",
						fillOpacity: 0.85,
						weight: 3,
						opacity: 1,
					})
					substationFences.push(fenceData);
				}
			});
		});

		google.maps.event.addListener(map, "zoom_changed", function (event) {
			substationFences.forEach(fence => {
				fence.data.setMap(map.getZoom() >= fence.zoom ? window.map : null);
			});
		});

		// Fit bounds
		window.existingTransmissionLines.forEach((line) => {
			line.forEach(feature => {
				feature.getGeometry().forEachLatLng((coordinate) => {
					bounds.extend(coordinate);
				});
			});
		});
		window.proposedTransmissionLines.forEach((line) => {
			line.forEach(feature => {
				feature.getGeometry().forEachLatLng((coordinate) => {
					bounds.extend(coordinate);
				});
			});
		});

		window.map.fitBounds(bounds);

		// Set zoom for single projects and landing page map and remove google maps event listeners.
		window.map.addListener("bounds_changed", () => {
			window.map.setOptions({
				maxZoom: null,
			});
			window.map.addListener("idle", () => {
				projects.length > 1 ? window.map.setZoom(9.8) : null;
				google.maps.event.clearListeners(window.map, "bounds_changed");
				google.maps.event.clearListeners(window.map, "idle");
			});
		});

		// Legend hide and toggle based on layer type.
		let legendItem = document.querySelectorAll(".legend-layer-toggle");

		legendItem.forEach((element) => {
			element.addEventListener("click", () => {
				let layer = eval(element.dataset.id);
				for (const [key, value] of Object.entries(layer)) {
					value.setMap(element.checked ? window.map : null)
				}
			});
		});

		// Info Window
		const showInfoWindow = (type, content, offset, position, url = null) => {
			let infoWindowContent = null;
			if (type == "substation" || type == "line" || type == "simulation") {
				infoWindowContent = `<h5 class="text-secondary text-center mb-0 mt-3">${content}</h5>`;
				is_home() && url ? (infoWindowContent += `<a class="info-window-btn bge-purple-gradient-x rounded-1 text-white text-decoration-none mx-auto d-block py-2 px-4 my-2" href="${url}">View Project</a>`) : null;
			} else {
				infoWindowContent = `<h5 class="text-secondary mt-3">${content.title}</h5>
								<p class="mb-2 fs-6">${content.locationName}</p>
								<p class="mb-2 fs-6">${content.address}</p>
								<p class="mb-0 fs-6">${content.date}</p>`;
			}

			infowindow.setOptions({
				pixelOffset: new google.maps.Size(0, offset),
				content: infoWindowContent,
			});
			infowindow.setPosition(position);
			infowindow.open(map);
			infowindow.setZIndex(5);
		};

		const infowindow = new google.maps.InfoWindow({});

		// Create the search box and link it to the UI element.
		const input = document.getElementById("map-search");
		const searchBox = new google.maps.places.SearchBox(input);

		// map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
		// Bias the SearchBox results towards current map's viewport.
		window.map.addListener("bounds_changed", () => {
			searchBox.setBounds(map.getBounds());
		});

		let markers = [];

		// Listen for the event fired when the user selects a prediction and retrieve
		// more details for that place.
		searchBox.addListener("places_changed", () => {
			const places = searchBox.getPlaces();

			if (places.length == 0) {
				return;
			}

			// Clear out the old markers.
			markers.forEach((marker) => {
				marker.setMap(null);
			});
			markers = [];

			// For each place, get the icon, name and location.
			const bounds = new google.maps.LatLngBounds();

			places.forEach((place) => {
				if (!place.geometry || !place.geometry.location) {
					console.log("Returned place contains no geometry");
					return;
				}

				const icon = {
					url: place.icon,
					size: new google.maps.Size(71, 71),
					origin: new google.maps.Point(0, 0),
					anchor: new google.maps.Point(17, 34),
					scaledSize: new google.maps.Size(25, 25),
				};

				// Create a marker for each place.
				markers.push(
					new google.maps.Marker({
						map,
						icon,
						title: place.name,
						position: place.geometry.location,
					})
				);
				if (place.geometry.viewport) {
					// Only geocodes have viewport.
					bounds.union(place.geometry.viewport);
				} else {
					bounds.extend(place.geometry.location);
				}
			});
			window.map.fitBounds(bounds);
		});
	};
}

// Scroll to Top & Sticky Nav
let scrollBtn = document.getElementById("scroll-to-top"),
	stickyNav = document.getElementById('secondary-nav');

window.onscroll = () => {
	scrollFunc();
	stickyNavFunc();
};

const stickyNavFunc = () => {
	if (stickyNav) {
		if (document.body.scrollTop > 85 || document.documentElement.scrollTop > 85) {
			stickyNav.classList.add('sticky');
		} else {
			stickyNav.classList.remove("sticky");
		}
	}
}

const scrollFunc = () => {
	if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
		scrollBtn.style.display = "block";
	} else {
		scrollBtn.style.display = "none";
	}
}

const scrollToTopFunc = () => {
	document.body.scrollTop = 0;
	document.documentElement.scrollTop = 0;
};

scrollBtn.onclick = () => {
	scrollToTopFunc();
};


// Intro Modal
jQuery(document).ready(function () {
	if (!sessionStorage.getItem("bgeSession")) {
		jQuery("#intro-modal").modal("show");
		sessionStorage.setItem("bgeSession", "seen");
	}
	// Communicate with the iframe to get click events for restyling iframe to go fullscreen.
    const mapforgeIframe = document.getElementById('mapforge-iframe');
	
	// mapforgeIframe.onload = () => {
		mapforgeIframe.contentWindow.document.body.addEventListener('click', function(event) {
			if (!event.target.closest('button')) {
				return;
			} else {
				if (event.target.closest('button').classList.contains('view-sim')) {
					mapforgeIframe.parentElement.style = "position: fixed; top: 0; left: 0; right: 0; height: 100vh; z-index: 9999999; clip-path: none;";
					document.body.style.overflow = 'hidden';
				} else if (event.target.closest('button').classList.contains('close-sim')) {
					document.body.style.overflow = 'auto';
					mapforgeIframe.parentElement.style = "";
				}
			}
		});
	// }	
});
